export default "/images/contest3.jpg?82755f076553a1b9333d23c4ad002fa5";